export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_ONBOARDING_CATEGORY":
      return action.payload;
    case "CREATE_ONBOARDING_CATEGORY":
      return [...state, action.payload];
    default:
      return state;
  }
};
